const RESERVED_FACEBOOK_PATHS = new Set([
  "dialog",
  "events",
  "groups",
  "login",
  "marketplace",
  "pages",
  "plugins",
  "share",
  "sharer",
  "stories",
])

export function buildWhatsAppHref(value?: string | null): string | null {
  const digits = String(value || "").replace(/\D/g, "")
  if (!digits) return null

  const normalized =
    digits.startsWith("01") && digits.length === 11
      ? `88${digits}`
      : digits

  return normalized.length >= 8 ? `https://wa.me/${normalized}` : null
}

export function buildMessengerHref(value?: string | null): string | null {
  const raw = String(value || "").trim()
  if (!raw) return null

  const directHandle = raw
    .replace(/^@/, "")
    .trim()

  if (/^[a-zA-Z0-9.]{3,}$/.test(directHandle)) {
    return `https://m.me/${directHandle}`
  }

  let url: URL
  try {
    url = new URL(raw.startsWith("http") ? raw : `https://${raw}`)
  } catch {
    return null
  }

  const host = url.hostname.replace(/^www\./, "").replace(/^web\./, "").replace(/^m\./, "")
  if (host !== "facebook.com" && host !== "fb.com") return null

  if (url.pathname === "/profile.php") {
    const id = url.searchParams.get("id")
    return id && /^\d+$/.test(id) ? `https://m.me/${id}` : null
  }

  const [handle] = url.pathname.split("/").filter(Boolean)
  if (!handle || RESERVED_FACEBOOK_PATHS.has(handle.toLowerCase())) {
    return null
  }

  return /^[a-zA-Z0-9.]{3,}$/.test(handle) ? `https://m.me/${handle}` : null
}
